import MaxSip from "./index";

const Routes = [
  {
    path: "/",
    component: MaxSip,
  }
];

export default Routes;